import topic from '../topic'
export const swstAPI = {
  getSwsts: topic.swstTopic + '/get_swsts',
  editSwst: topic.swstTopic + '/edit_swst',
}